import { RouteObject } from 'react-router'
import { ConfirmAppointmentPage } from '../pages/confirm-appointment'
import { CancelAppointmentPage } from '../pages/cancel-appointment'

export enum PublicAppointmentRoutePath {
  AppointmentConfirm = '/appointments/:id/confirm',
  AppointmentCancel = '/appointments/:id/cancel',
}

export const publicAppointmentRoutes: RouteObject[] = [
  {
    path: PublicAppointmentRoutePath.AppointmentConfirm,
    element: <ConfirmAppointmentPage />,
  },
  {
    path: PublicAppointmentRoutePath.AppointmentCancel,
    element: <CancelAppointmentPage />,
  },
]
